import { render, staticRenderFns } from "./YoutubeVideo.vue?vue&type=template&id=6b40c52f&scoped=true&"
import script from "./YoutubeVideo.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideo.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeVideo.vue?vue&type=style&index=0&id=6b40c52f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40c52f",
  null
  
)

export default component.exports